<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-class="redmfu">
                <div slot="header" v-if="thai_student==1">
                  <strong>ตอนที่ 2 สำหรับผู้มีงานทำ</strong>
                  <div style="float:right;"
                  >
                    <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                      {{ this.$store.state.timeExp }}
                    </b-badge>
                  </div>
                </div>
                <div slot="header" v-if="thai_student==0">
                  <strong>Part 2 For Employed graduates</strong>
                  <div style="float:right;"
                  >
                    <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                      {{ this.$store.state.timeExp }}
                    </b-badge>
                  </div>
                </div>
                <div v-for="item in items" v-bind:key="item.QUESTION_PK">
                  <div v-if="item.QUESTION_PK=='8'">
                    <strong v-if="thai_student==1">สถานที่ทำงานปัจจุบัน (โปรดระบุให้ชัดเจน
                      เพราะมีความสำคัญต่อการพัฒนาบัณฑิตของมหาวิทยาลัย)</strong>
                    <strong v-else>Current Work Address (Please provide clear information, the information is important
                      for graduate development.) </strong>
                  </div>
                  <b-form-group
                    class="text-danger"
                    v-if="(items2[item.QUESTION_PK-5].VALUES ==2)"
                    :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    v-else
                    :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    label-cols-sm="1"
                    label
                    label-align-sm="right"
                    label-for="nested-street"
                  >
                    <div v-if="qn_income==3 && item.QUESTION_PK==5">
                      <b-form-radio-group
                        v-if="item.QUESTION_PK==5 && thai_student==1"
                        v-model="selected_occup_type"
                        value-field="BYTECODE"
                        text-field="BYTEDES"
                        :options="option_thai"
                        stacked
                        name="selected_occup_type"
                      >
                        <b-form-input
                          v-if="selected_occup_type=='0' "
                          id="qn_occup_type_txt"
                          type="text"
                          autocomplete="qn_occup_type_txt"
                          v-model="qn_occup_type_txt"
                          placeholder="Other(Please specify)"
                        ></b-form-input>
                        <div v-if="selected_occup_type=='4'">
                          <b-form-input
                            v-if=" selected_occup_type=='4'"
                            id="qn_occup_type_txt"
                            type="text"
                            autocomplete="qn_occup_type_txt"
                            v-model="qn_occup_type_txt"
                            placeholder="Specify your product/service"
                          ></b-form-input>
                        </div>
                      </b-form-radio-group>
                      <b-form-radio-group
                        v-if="item.QUESTION_PK==5 && thai_student==0"
                        v-model="selected_occup_type"
                        value-field="BYTECODE"
                        text-field="BYTEDES"
                        :options="option_eng"
                        stacked
                        name="selected_occup_type"
                      >
                        <b-form-input
                          v-if="selected_occup_type=='0' "
                          id="qn_occup_type_txt"
                          type="text"
                          autocomplete="qn_occup_type_txt"
                          v-model="qn_occup_type_txt"
                          placeholder="Other(Please specify)"
                        ></b-form-input>
                        <b-form-input
                          v-if=" selected_occup_type=='4'"
                          id="qn_occup_type_txt"
                          type="text"
                          autocomplete="qn_occup_type_txt"
                          v-model="qn_occup_type_txt"
                          placeholder="Specify your product/service"
                        ></b-form-input>
                      </b-form-radio-group>


                    </div>
                    <div v-else>
                      <b-form-radio-group
                        v-if="item.QUESTION_PK==5"
                        v-model="selected_occup_type"
                        value-field="BYTECODE"
                        text-field="BYTEDES"
                        :options="items[0].ANS"
                        stacked
                        name="selected_occup_type"
                      >
                        <b-form-group v-if="selected_occup_type=='0'">
                          <b-form-input

                            id="qn_occup_type_txt"
                            type="text"
                            autocomplete="qn_occup_type_txt"
                            v-model="qn_occup_type_txt"
                            placeholder="Other(Please specify)"
                          ></b-form-input>
                          <b-form-invalid-feedback :state="validation_occup"  >
                            Your Spell must be 3-100 characters long.
                          </b-form-invalid-feedback>
                          <b-form-valid-feedback :state="validation_occup">
                            Correct.
                          </b-form-valid-feedback>
                        </b-form-group>

                        <b-form-group v-if=" selected_occup_type=='4'" >
                          <b-form-input
                            id="qn_occup_type_txt"
                            type="text"
                            autocomplete="qn_occup_type_txt"
                            v-model="qn_occup_type_txt"
                            placeholder="Specify your product/service"
                            :state="validation_occup"
                          ></b-form-input>
                          <b-form-invalid-feedback :state="validation_occup">
                            Your Spell must be 3-100 characters long.
                          </b-form-invalid-feedback>
                          <b-form-valid-feedback :state="validation_occup">
                            Correct.
                          </b-form-valid-feedback>

                        </b-form-group>
                      </b-form-radio-group>
                    </div>

                    <b-form-radio-group
                      v-if="item.QUESTION_PK==6"
                      v-model="selected_talent"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="items[1].ANS"
                      stacked
                      name="selected_talent"
                    >
                      <!-- select:{{ selected_talent }} -->
                      <b-form-input
                        v-if="selected_talent=='0'"
                        id="qn_talent_txt"
                        type="text"
                        autocomplete="qn_talent_txt"
                        v-model="qn_talent_txt"
                        placeholder="Other..."
                        :state="validation_talent"
                      ></b-form-input>
                    </b-form-radio-group>

                    <v-select
                      v-if="item.CONTROL_Q==2 && item.QUESTION_PK=='7' && thai_student==1 "
                      label="POS_NAME"
                      :options="positionItems"
                      :selected="current_position"
                      v-model="select_position1"
                      @input="selectPositionOnchange"
                      placeholder="พิมพ์คำค้นหาเป็นภาษาไทย แล้วเลือกตำแหน่งที่ถูกต้องใน listbox"
                    ></v-select>

                    <div v-if=" item.QUESTION_PK=='7' && thai_student==0 ">
                      <b-form-group>
                        <b-form-input
                          v-if=" item.QUESTION_PK=='7' && thai_student==0 "
                          id="current_position"
                          type="text"
                          autocomplete="current_position"
                          v-model="current_position"
                          :state="validation_job"
                        ></b-form-input>
                        <b-form-invalid-feedback :state="validation_job">
                          Your position must be 4-50 characters long.
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validation_job">
                          Correct.
                        </b-form-valid-feedback>
                      </b-form-group>
                    </div>

                    <div v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='8'">
                      <b-form-input
                        v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='8'"
                        id="current_office"
                        type="text"
                        autocomplete="current_office"
                        v-model="current_office"
                        :state="validation_office"
                      ></b-form-input>

                      <!--                      <font color="#663399">แทรกข้อ 9 ด้วย</font>-->
                      <b-form-invalid-feedback :state="validation_office">
                        Your office must be 3-100 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_office">
                        Correct.
                      </b-form-valid-feedback>
                    </div>


                    <div v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='9'">
                      <b-form-input
                        v-if="item.CONTROL_Q==1 && item.QUESTION_PK=='9'"
                        id="current_department_name"
                        type="text"
                        autocomplete="current_department_name"
                        v-model="current_department_name"
                        :state="validation_department"
                      ></b-form-input>
                      <b-form-invalid-feedback :state="validation_department">
                        Your department must be 3-100 characters long.
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback :state="validation_department">
                        Correct.
                      </b-form-valid-feedback>
                    </div>
                    <b-form-radio-group
                      v-if="item.QUESTION_PK==10"
                      v-model="selected_work_type"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="items[5].ANS"
                      stacked
                      name="selected_work_type"
                    >
                      <!--                      select:{{ selected_work_type }}-->
                    </b-form-radio-group>

                    <!--                    <v-select v-if="item.CONTROL_Q==2 && item.QUESTION_PK=='11'  "-->
                    <!--                              label="COUNTRYNAME"-->
                    <!--                              :options="countryItems"-->
                    <!--                              v-model="select_country1"-->
                    <!--                              @input="selectCountryOnchange"-->
                    <!--                    ></v-select>-->
                  </b-form-group>
                </div>
                <div slot="footer" class="text-center">
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>
                  <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                    <i class="fa fa-dot-circle-o"></i> Submit
                  </b-button>

                  <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                    <i class="fa fa-ban"></i> Reset
                  </b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal v-if="thai_student==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="thai_student==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      number: 0,
      number20: 0,
      number21: 0,
      number22: 0,
      number23: 0,
      student: {},
      std_id: "",
      qn_income: "",

      option_thai: [
        {BYTECODE: "0", BYTEDES: "อื่นๆ (ระบุ)   ", CONTROL_ANS: 0, QUESTION_PK: 5}
      ],
      option_eng: [
        {BYTECODE: "0", BYTEDES: "Other (Please specify)   ", CONTROL_ANS: 0, QUESTION_PK: 5}
      ],
      selected_occup_type: "",
      selected_mfii: "",
      qn_mfii_txt: "",
      selected_talent: "",
      current_department_name: "",
      selected_work_type: "",
      qn_occup_type_txt: "",
      // qn_occup_type_txt4:"",
      qn_work_status: "",
      qn_talent_txt: "",
      selected_work_satisfy: "",
      qn_work_satisfy_txt: "",
      selected_time_findwork: "",
      selected_match_edu: "",
      selected_apply_edu: "",
      select_other: 0,
      selected_work_success1: "",
      selected_work_success2: "",
      selected_work_success3: "",
      qn_work_success1_txt: "",
      qn_work_success2_txt: "",
      qn_work_success3_txt: "",
      selected_require_edu: "",
      sex: "",
      thai_student: "",
      current_erorrtxt: "",
      dangerModal: false,
      current_position: "",
      current_no: "",
      current_village: "",
      current_moo: "",
      current_lane: "",
      current_road: "",
      current_zipcode: "",
      current_address: "",
      current_building: "",
      current_tel: "",
      current_fax: "",
      current_email: "",
      current_salary: "",
      items: [],
      item1s: [],
      items2: [],
      item2s: [],
      item3s: [],
      current_office: "",
      select_position: 0,
      select_position1: "",
      positionItems: [],
      select_country_name: "",
      countryItems: [],
      select_province: 0,
      provinceItems: [],
      select_district: 0,
      districtItems: [],
      select_subdistrict: 0,
      select_subdistrict_name: "",
      subdistrictItems: [],
      select_country: "",
      select_country1: "",
      actionUpdate: 10,
      w_success1: 0,
      w_success2: 0,
      w_success3: 0,
    };
  }, computed: {
    validation_occup() {
      var substring = "--";
      var zerochar = "00000";
      var substring00 = "00";
      var substring55 = "55555";
      var stringquestion = "??";
      var substring2="——";
      var substring3="__";
      var substring4="- -";
      var starstring="**";
      var pointstring='..';

      // if ((this.qn_occup_type_txt != null)) {
      if (this.qn_occup_type_txt != "" && this.qn_occup_type_txt != null && this.qn_occup_type_txt != undefined) {
          if (this.qn_occup_type_txt.toString().length > 0) {

            if (this.qn_occup_type_txt.includes(substring) || this.qn_occup_type_txt.includes(substring2)
              || this.qn_occup_type_txt.includes(substring3) || this.qn_occup_type_txt.includes(substring4)
              || this.qn_occup_type_txt.includes(starstring) || this.qn_occup_type_txt.includes(pointstring)
            ) {
              return false;
            }
          }


        if (this.qn_occup_type_txt.length >= 3 && this.qn_occup_type_txt.length < 100) {
          if (this.qn_occup_type_txt.includes(substring) || this.qn_occup_type_txt.includes(zerochar)
            || this.qn_occup_type_txt.includes(substring00) || this.qn_occup_type_txt.includes(substring55)
            || this.qn_occup_type_txt.includes(stringquestion) || this.qn_occup_type_txt.includes(substring2)
            || this.qn_occup_type_txt.includes(substring3) || this.qn_occup_type_txt.includes(substring4)
            || this.qn_occup_type_txt.includes(starstring) || this.qn_occup_type_txt.includes(pointstring)) {
            // console.log("f421")
            return false;
          } else {
            // console.log("f424")
            return true;
          }
        } else {
          // console.log("f428")
          return false;
        }
      } else {
        // console.log("f433")
        return false;
      }
    },
    validation_talent() {
      var substring = "--";
      var zerochar = "00000";
      var substring00 = "00";
      var substring55 = "55555";
      var stringquestion = "??";
      var substring2="——";
      var substring3="__";
      var substring4="- -";
      var starstring="**";
      var pointstring='..';

      // if ((this.qn_occup_type_txt != null)) {
      if (this.qn_talent_txt != "" && this.qn_talent_txt != null && this.qn_talent_txt != undefined) {
        if (this.qn_talent_txt.toString().length > 0) {

          if (this.qn_talent_txt.includes(substring) || this.qn_talent_txt.includes(substring2)
            || this.qn_talent_txt.includes(substring3) || this.qn_talent_txt.includes(substring4)
            || this.qn_talent_txt.includes(substring4) || this.qn_talent_txt.includes(starstring)
            || this.qn_talent_txt.includes(pointstring)
          ) {
            return false;
          }
        }
        if (this.qn_talent_txt.length >= 3 && this.qn_talent_txt.length < 100) {
          if (this.qn_talent_txt.includes(substring) || this.qn_talent_txt.includes(zerochar)
            || this.qn_talent_txt.includes(substring00) || this.qn_talent_txt.includes(substring55)
            || this.qn_talent_txt.includes(stringquestion)|| this.qn_talent_txt.includes(substring2)
            || this.qn_talent_txt.includes(substring3) || this.qn_talent_txt.includes(substring4)
            || this.qn_talent_txt.includes(substring4) || this.qn_talent_txt.includes(starstring)
            || this.qn_talent_txt.includes(pointstring)) {
            // console.log("f421")
            return false;
          } else {
            // console.log("f424")
            return true;
          }
        } else {
          // console.log("f428")
          return false;
        }
      } else {
        // console.log("f433")
        return false;
      }
    },
    validation_salary() {
      var comma_string = ",";
      if (this.current_salary != null && this.current_salary != undefined && this.current_salary != '') {
        if ((this.current_salary.length >= 4) && (this.current_salary.length <= 7)) {
          if (this.current_salary.includes(comma_string)) {
            return false;
          } else {
            if (this.validSalary()) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }

      } else {
        return false;
      }
    },
    /*validation_email() {
      // var re = /^(([^<>()\[\]\\.,;:\s@"](\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var re = /^(([^<>()\[\]\\.,;:\s@"](\.[^<>()\[\]\\.,;:\s@"]+)*);
      if (this.current_email != null) {
        if ( this.current_email.length >= 5 && this.current_email.length < 50){

          console.log("validEmail==",this.current_email,this.current_email.match(re) );
        }else{
          return false;
        }
        // if (re.test(this.current_email)){
        //   return true;
        // }else{
        //   return false;
        // }
      } else {
        return false;
      }
      console.log("validEmail==",email,re.test(email));
      // return re.test(email);
    }, */
    validation_fax() {
      var spacestring = " ";
      if (this.current_fax != null && this.current_fax != '' && this.current_fax != undefined) {
        if (this.current_fax == "-") {
          return true;
        } else {
          if (this.current_fax.length >= 9 && this.current_fax.length <= 30) {
            if (this.current_fax.includes(spacestring)) {
              return false;
            } else {
              // console.log("fax==", this.validFax());
              if (this.validFax()) {
                return true;
              } else {
                return false;
              }
            }
          } else {
            return false;
          }
        }
      }

    },
    validation_tel() {
      var substring = "-";
      var spacestring = " ";
      var zerochar = "00000";
      if (this.current_tel != null && this.current_tel != '' && this.current_tel != undefined) {
        if (this.current_tel.length >= 9 && this.current_tel.length <= 30) {
          if ((this.current_tel.includes(substring)) || (this.current_tel.includes(spacestring)) || (this.current_tel.includes(zerochar))) {
            return false;
          } else {
            // console.log("this.validPhone() ==", this.validPhone());
            if (this.validPhone()) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validation_job() {
      var substring = "--";
      var zerochar = "00000";
      var substring00 = "00";
      var substring55 = "55";
      var stringquestion = "??";
      if ((this.current_position != null)) {
        if (this.current_position.length >= 5 && this.current_position.length < 50) {
          if (this.current_position.includes(substring) || this.current_position.includes(zerochar)
            || this.current_position.includes(substring00) || this.current_position.includes(substring55)
            || this.current_position.includes(stringquestion)) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }

      } else {
        return false;
      }
    },
    validation_office() {
      var substring = "--";
      var substring2="——";
      var substring3="__";
      var starstring="**";
      var zerochar = "00000";
      var substring00 = "00";
      var substring55 = "55";
      var stringquestion = "??";
      var pointstring="..";
      var substring4="- -";
      if (this.current_office != null && this.current_office != '' && this.current_office != undefined) {
        if (this.current_office.length >= 3 && this.current_office.length < 100) {
          if (this.current_office.includes(substring) || this.current_office.includes(zerochar)
            || this.current_office.includes(substring00) || this.current_office.includes(substring55)
            || this.current_office.includes(stringquestion)  || this.current_office.includes(substring2)
            || this.current_office.includes(substring3) || this.current_office.includes(starstring)
            || this.current_office.includes(pointstring) || this.current_office.includes(substring4) ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validation_department() {
      var substring = "--";
      var substring2="——";
      var substring3="__";
      var starstring="**";
      var zerochar = "00000";
      var substring00 = "00";
      var substring55 = "55";
      var stringquestion = "??";
      var pointstring="..";
      var substring4="- -";
      if (this.current_department_name != null && this.current_department_name != '' && this.current_department_name != undefined) {
        if (this.current_department_name.length >= 3 && this.current_department_name.length < 100) {
          if (this.current_department_name.includes(substring) || this.current_department_name.includes(zerochar)
            || this.current_department_name.includes(substring00) || this.current_department_name.includes(substring55)
            || this.current_department_name.includes(stringquestion) || this.current_department_name.includes(substring4)
            || this.current_department_name.includes(substring2)
            || this.current_department_name.includes(substring3)
            || this.current_department_name.includes(starstring)
            || this.current_department_name.includes(pointstring) ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    /* validation_no() {
       var substring = "-";
       var slash = "/";
       var bracket_open = "(";
       var bracket_close = ")";
       var square = "#";
       var star = "*";
       var space = " ";
       var after_no = this.current_no;
       // this.current_no="asdfadfsas-fsdfasd";
       //console.log("ก่อน==", this.current_no);
       if (this.current_no != null && this.current_no != ""  && this.current_no != undefined ) {
         if (!((this.current_no > 1) || (this.current_no > 99999))) {
           if (after_no.includes(substring)) {
             after_no = after_no.replace(substring, '');
             // console.log("new-==",after_no);
           }
           if (after_no.includes(slash)) {
             after_no = after_no.replace(slash, '');
             // console.log("new/==",after_no);
           }
           if (after_no.includes(bracket_open)) {
             after_no = after_no.replace(bracket_open, '');
             // console.log("new(==",after_no);
           }
           if (after_no.includes(bracket_close)) {
             after_no = after_no.replace(bracket_close, '');
             // console.log("new)==",after_no);
           }
           if (after_no.includes(square)) {
             after_no = after_no.replace(square, '');
             // console.log("new#==",after_no);
           }
           if (after_no.includes(star)) {
             after_no = after_no.replace(star, '');
             // console.log("new*==",after_no);
           }
           if (after_no.includes(space)) {
             after_no = after_no.replace(space, '');
             // console.log("new ว่าง==",after_no);
           }
           if ((after_no > 1) || (after_no < 9999999)) {
             // console.log("true")
             return true;
           } else if (this.current_no == "-") {
             // console.log("-----true------")
             return true;
           } else {
             // console.log("false")
             return false;
           }

         }

       } else {
         return false;
       }

     }
     ,*/
    /* validation_village() {
       if (this.current_village != null) {
         return this.current_village.length >= 1 && this.current_village.length < 50
       } else {
         return false;
       }
     },
     validation_build() {
       if (this.current_building != null) {
         return this.current_building.length >= 1 && this.current_building.length < 50
       } else {
         return false;
       }
     },
     validation_road() {
       if (this.current_road != null) {
         return this.current_road.length >= 1 && this.current_road.length < 50
       } else {
         return false;
       }
     },
     validation_soi() {
       if (this.current_lane != null) {
         return this.current_lane.length >= 1 && this.current_lane.length < 50
       } else {
         return false;
       }
     },
     validation_moo() {
       if (this.current_moo != null) {
         return this.current_moo.length >= 1 && this.current_moo.length < 50
       } else {
         return false;
       }
     },
     validation_add() {
       if (this.current_address != null) {
         return this.current_address.length >= 10 && this.current_address.length < 500
       } else {
         return false;
       }
     }*/

  },
  components: {
    vSelect
  },
  methods: {

    onBack() {
      this.$router.push("/part1");
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // console.log("validEmail==",email,re.test(email));
      return re.test(email);
    },
    validFax() {
      //var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      var phoneno9 = /^\d{9}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;

      if (this.current_fax.match(phoneno9) || this.current_fax.match(phoneno10) || this.current_fax.match(phoneno11) || this.current_fax.match(phoneno12)
        || this.current_fax.match(phoneno13) || this.current_fax.match(phoneno14)
        || this.current_fax.match(phoneno15) || this.current_fax.match(phoneno16) || this.current_fax.match(phoneno17) || this.current_fax.match(phoneno18)
        || this.current_fax.match(phoneno19) || this.current_fax.match(phoneno20) || this.current_fax.match(phoneno21) || this.current_fax.match(phoneno22)
        || this.current_fax.match(phoneno23) || this.current_fax.match(phoneno24) || this.current_fax.match(phoneno25) || this.current_fax.match(phoneno26)
        || this.current_fax.match(phoneno27) || this.current_fax.match(phoneno28) || this.current_fax.match(phoneno29) || this.current_fax.match(phoneno30)) {
        // console.log("--------true---------",this.current_fax);
        return true;
      } else {
        if (this.current_fax == "-") {
          return true;
        } else {
          return false;
        }
      }
    },
    validPhone() {
      //var phoneno = /^\(?([0-9]{2})\)?[-]?([0-9]{4})[-]?([0-9]{4})$/; // /^\d{10}$/;  // /^[0-9]\d{2}-\d{3}-\d{4}$/;
      var phoneno9 = /^\d{9}$/;
      var phoneno10 = /^\d{10}$/;
      var phoneno11 = /^\d{11}$/;
      var phoneno12 = /^\d{12}$/;
      var phoneno13 = /^\d{13}$/;
      var phoneno14 = /^\d{14}$/;
      var phoneno15 = /^\d{15}$/;
      var phoneno16 = /^\d{16}$/;
      var phoneno17 = /^\d{17}$/;
      var phoneno18 = /^\d{18}$/;
      var phoneno19 = /^\d{19}$/;
      var phoneno20 = /^\d{20}$/;
      var phoneno21 = /^\d{21}$/;
      var phoneno22 = /^\d{22}$/;
      var phoneno23 = /^\d{23}$/;
      var phoneno24 = /^\d{24}$/;
      var phoneno25 = /^\d{25}$/;
      var phoneno26 = /^\d{26}$/;
      var phoneno27 = /^\d{27}$/;
      var phoneno28 = /^\d{28}$/;
      var phoneno29 = /^\d{29}$/;
      var phoneno30 = /^\d{30}$/;

      if (this.current_tel.match(phoneno9) || this.current_tel.match(phoneno10) || this.current_tel.match(phoneno11) || this.current_tel.match(phoneno12)
        || this.current_tel.match(phoneno13) || this.current_tel.match(phoneno14)
        || this.current_tel.match(phoneno15) || this.current_tel.match(phoneno16) || this.current_tel.match(phoneno17) || this.current_tel.match(phoneno18)
        || this.current_tel.match(phoneno19) || this.current_tel.match(phoneno20) || this.current_tel.match(phoneno21) || this.current_tel.match(phoneno22)
        || this.current_tel.match(phoneno23) || this.current_tel.match(phoneno24) || this.current_tel.match(phoneno25) || this.current_tel.match(phoneno26)
        || this.current_tel.match(phoneno27) || this.current_tel.match(phoneno28) || this.current_tel.match(phoneno29) || this.current_tel.match(phoneno30)) {
        // console.log("932--------true---------",this.current_tel);
        return true;
      } else {
        // console.log("935--------false---------",this.current_tel);
        return false;
      }
    },
    validSalary() {
      var salary3 = /^\d{3}$/;
      var salary4 = /^\d{4}$/;
      var salary5 = /^\d{5}$/;
      var salary6 = /^\d{6}$/;
      var salary7 = /^\d{7}$/;
      if (this.current_salary.match(salary3) || this.current_salary.match(salary4) || this.current_salary.match(salary5) || this.current_salary.match(salary6) || this.current_salary.match(salary7)) {
        // console.log("true==", this.current_salary);
        return true;
      } else {
        // console.log("false==", this.current_salary);
        return false;
      }
    },
    isNumeric: function (n) {
      if ((n > 999) || (n <= 9999999)) {
        return true;
      } else {
        return false;
      }
    },
    // wrongNumber: function () {
    //   //  this.isNumeric(this.current_salary) == false
    //   //  console.log("-------wrongNumber----------",this.isNumeric(this.current_salary));
    //   return this.isNumeric(this.current_salary);
    // },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("-------res----------",res.data.data);
          if (res.data.data.length > 0) {
            this.actionUpdate = 1;
            var currentSt = res.data.data[0];
            this.std_id = this.student.STUDENTID;
            this.qn_income = currentSt.QN_INCOME;
            if (this.qn_income == 3) {
              this.selected_occup_type = 0;
            } else {
              this.selected_occup_type = currentSt.QN_OCCUP_TYPE;
            }
            this.qn_work_status = currentSt.QN_WORK_STATUS;
            if (this.selected_occup_type == 0) {
              this.qn_occup_type_txt = currentSt.QN_OCCUP_TYPE_TXT;
            }
            if (this.selected_occup_type == 4) {
              this.qn_occup_type_txt = currentSt.QN_OCCUP_TYPE_TXT4;
            }
            this.selected_mfii = currentSt.QN_MFII;
            this.qn_mfii_txt = currentSt.QN_MFII_TXT;
            this.selected_talent = currentSt.QN_TALENT;
            this.qn_talent_txt = currentSt.QN_TALENT_TXT;
            this.select_position = currentSt.QN_POS_ID;
            if (this.thai_student == 1) {
              // console.log("ไทย", currentSt.QN_POS_ENG, "==", currentSt.QN_POS_ID)
              this.select_position1 = currentSt.QN_POS_ENG;
              this.current_position = currentSt.QN_POS_ENG;
            } else {
              this.current_position = currentSt.QN_POS_ENG;
            }
            this.current_office = currentSt.QN_WORK_NAME;
            this.current_department_name = currentSt.QN_DEPARTMENT_NAME;
            // console.log("current_department_name", currentSt.QN_DEPARTMENT_NAME)
            this.selected_work_type = currentSt.QN_WORKTYPE_ID;
            this.select_country = currentSt.QN_WORK_NATION;
            this.select_country1 = currentSt.QN_WORK_NATION_NAME;
            this.select_country_name = currentSt.QN_WORK_NATION_NAME;

            if (currentSt.QN_WORK_NATION == 'TH') {
              this.current_no = currentSt.QN_WORK_ADD;
              this.current_moo = currentSt.QN_WORK_MOO;

              this.current_building = currentSt.QN_WORK_BUILDING;
              this.current_lane = currentSt.QN_WORK_SOI;
              this.current_road = currentSt.QN_WORK_STREET;
              this.select_province = currentSt.QN_WORK_PROVINCE;
              this.onloadDistrictById();
              this.select_district = currentSt.QN_WORK_DISTRICT;
              // console.log("select_district==", currentSt.QN_WORK_DISTRICT);
              this.select_subdistrict = currentSt.QN_WORK_TAMBON;
              // console.log("select_subdistrict==", currentSt.QN_WORK_TAMBON);
              this.select_subdistrict_name = currentSt.QN_WORK_TAMBON_NAME;
              this.current_zipcode = currentSt.QN_WORK_ZIPCODE;
              this.onloadSubDistrictById();
            } else {
              this.select_country = currentSt.QN_WORK_NATION;
              this.current_address = currentSt.QN_WORK_ADDRESS;
            }
            this.current_tel = currentSt.QN_WORK_TEL;
            this.current_fax = currentSt.QN_WORK_FAX;
            // console.log("email==",currentSt.QN_WORK_EMAIL)
            if ((currentSt.QN_WORK_EMAIL == '') || (currentSt.QN_WORK_EMAIL == null) || (currentSt.QN_WORK_EMAIL == undefined)) {
              this.current_email = currentSt.CURRENT_EMAIL;
            } else {
              this.current_email = currentSt.QN_WORK_EMAIL;
            }
            // console.log("1020==", currentSt.QN_SALARY)
            this.current_salary = currentSt.QN_SALARY;
            this.selected_work_satisfy = currentSt.QN_WORK_SATISFY;
            this.qn_work_satisfy_txt = currentSt.QN_WORK_SATISFY_TXT;
            this.selected_time_findwork = currentSt.QN_TIME_FINDWORK;
            this.selected_match_edu = currentSt.QN_MATCH_EDU;
            this.selected_apply_edu = currentSt.QN_APPLY_EDU;
            this.selected_work_success1 = currentSt.WORK_SUCCESS1;
            this.selected_work_success2 = currentSt.WORK_SUCCESS2;
            this.selected_work_success3 = currentSt.WORK_SUCCESS3;

            this.qn_work_success1_txt = currentSt.WORK_SUCCESS_TEXT1;
            this.qn_work_success2_txt = currentSt.WORK_SUCCESS_TEXT2;
            this.qn_work_success3_txt = currentSt.WORK_SUCCESS_TEXT3;
            this.selected_require_edu = currentSt.QN_REQUIRE_EDU;
            this.getCountry(this.thai_student);
          } else {
            this.actionUpdate = 0;
          }
        })
        .catch(err => {
          this.actionUpdate = 10;
          console.log("getCurrentStudent", err.toString());
          // this.$router.push("Logout");
        });
      // console.log("actionUpdate==", this.actionUpdate);
    },
    getStudentQuestion() {
      this.std_id = this.$store.state.user.studentid;
      this.stdstudentId = this.$store.state.user.studentid;
      this.thai_student = this.$store.state.user.thaistudent;
      this.sex = this.$store.state.user.sex;
      var x = this.$route.query.x;
      var start = 0;
      // console.log("x==", isNaN(x));
      if (isNaN(x) || x <= 0) {
        start = 0;
      } else {
        start = parseInt(x);
      }

      this.getQuestion(2, this.sex, this.thai_student, start);
      // console.log("num==",this.number,this.number20)
      //เอาออก this.getQuestion(21, this.sex, this.thai_student, this.number20);
      // this.getQuestion(22, this.sex, this.thai_student,this.number21);
      // this.getQuestion(23, this.sex, this.thai_student,this.number22);

      // this.getProvince(this.thai_student);
      // this.onloadDistrictById(this.select_province);
      this.getPosition();
    },
    setStudent() {
      var student = {};
      student.std_id = this.$store.state.user.studentid;
      student.qn_year = this.$store.state.user.year;
      student.selected_occup_type = this.selected_occup_type;
      if (this.selected_occup_type == 0) {
        student.qn_occup_type_txt = this.qn_occup_type_txt
        student.qn_occup_type_txt4 = "";
      } else if (this.selected_occup_type == 4) {
        student.qn_occup_type_txt4 = this.qn_occup_type_txt
        student.qn_occup_type_txt = "";
        // console.log("qn_occup_type_txt4==", student.qn_occup_type_txt4)
      } else {
        student.qn_occup_type_txt = "";
        student.qn_occup_type_txt4 = "";
      }
      if ((this.selected_occup_type == null) || (this.selected_occup_type == '')) {
        this.items2[0].VALUES = 2;
      } else {
        if ((this.selected_occup_type == 0) && ((this.qn_occup_type_txt == '') || (this.qn_occup_type_txt == null) || (this.qn_occup_type_txt == undefined))) {
          this.items2[0].VALUES = 2;
        } else if ((this.selected_occup_type == 4) && ((this.qn_occup_type_txt == '') || (this.qn_occup_type_txt == null) || (this.qn_occup_type_txt == undefined))) {
          this.items2[0].VALUES = 2;
        } else {
          this.items2[0].VALUES = 1;
        }
      }

      student.selected_talent = this.selected_talent;
      if (this.selected_talent == 0) {
        student.qn_talent_txt = this.qn_talent_txt
        //.replaceAll( "'", "`");
      } else {
        student.qn_talent_txt = "";
      }
      if ((this.selected_talent == null) || (this.selected_talent == '') || (this.selected_talent == undefined)) {
        this.items2[1].VALUES = 2;
      } else {
        if ((this.selected_talent == 0) && ((this.qn_talent_txt == '') || (this.qn_talent_txt == null) || (this.qn_talent_txt == undefined))) {
          this.items2[1].VALUES = 2;
        } else {
          this.items2[1].VALUES = 1;
        }
      }
      if (this.thai_student == 1) {
        student.select_position = this.select_position;
        student.current_position = this.current_position;
        if ((this.select_position == null) || (this.select_position == '') || (this.select_position == undefined)) {
          this.items2[2].VALUES = 2;
        } else {
          this.items2[2].VALUES = 1;
        }
      } else {
        student.select_position = "";
        student.current_position = this.current_position
        //.replaceAll( "'", "`");
        if ((this.current_position == null) || (this.current_position == '') || (this.current_position == undefined)) {
          this.items2[2].VALUES = 2;
        } else {
          this.items2[2].VALUES = 1;
        }
      }
      student.current_office = this.current_office
      //.replaceAll( "'", "`");
      if ((this.current_office == null) || (this.current_office == '') || (this.current_office == undefined)) {
        this.items2[3].VALUES = 2;
      } else {
        this.items2[3].VALUES = 1;
      }
      student.current_department_name = this.current_department_name
      //.replaceAll( "'", "`");
      if ((this.current_department_name == null) || (this.current_department_name == '') || (this.current_department_name == undefined)) {
        this.items2[4].VALUES = 2;
      } else {
        this.items2[4].VALUES = 1;
      }
      student.selected_work_type = this.selected_work_type;
      if ((this.selected_work_type == null) || (this.selected_work_type == '') || (this.selected_work_type == undefined)) {
        this.items2[5].VALUES = 2;
      } else {
        this.items2[5].VALUES = 1;
      }
      student.select_country = this.select_country;
      if ((this.select_country == null) || (this.select_country == '') || (this.select_country == undefined)) {
        this.items2[6].VALUES = 2;
      } else {
        this.items2[6].VALUES = 1;
      }
      student.select_country_name = this.select_country_name;
      // console.log("setStudent==", student);
      return student;
    },
    checkQuotation(s) {
      var quotation1 = "'";
      var quotation2 = "`";

      if (s.qn_occup_type_txt != '' && s.qn_occup_type_txt != null && s.qn_occup_type_txt != undefined) {
        if (s.qn_occup_type_txt.toString().length > 0) {
          if (s.qn_occup_type_txt.includes(quotation1)) {
            s.qn_occup_type_txt = s.qn_occup_type_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_occup_type_txt.includes(quotation2)) {
            s.qn_occup_type_txt = s.qn_occup_type_txt.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.qn_occup_type_txt4 != '' && s.qn_occup_type_txt4 != null && s.qn_occup_type_txt4 != undefined) {
        if (s.qn_occup_type_txt4.toString().length > 0) {
          if (s.qn_occup_type_txt4.includes(quotation1)) {
            s.qn_occup_type_txt4 = s.qn_occup_type_txt4.replaceAll(quotation1, "''");
          }
          if (s.qn_occup_type_txt4.includes(quotation2)) {
            s.qn_occup_type_txt4 = s.qn_occup_type_txt4.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.qn_talent_txt != '' && s.qn_talent_txt != null && s.qn_talent_txt != undefined) {
        if (s.qn_talent_txt.toString().length > 0) {
          if (s.qn_talent_txt.includes(quotation1)) {
            s.qn_talent_txt = s.qn_talent_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_talent_txt.includes(quotation2)) {
            s.qn_talent_txt = s.qn_talent_txt.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_position != '' && s.current_position != null && s.current_position != undefined) {
        if (s.current_position.toString().length > 0) {
          if (s.current_position.includes(quotation1)) {
            s.current_position = s.current_position.replaceAll(quotation1, "''");
          }
          if (s.current_position.includes(quotation2)) {
            s.current_position = s.current_position.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_office != '' && s.current_office != null && s.current_office != undefined) {
        if (s.current_office.toString().length > 0) {
          if (s.current_office.includes(quotation1)) {
            s.current_office = s.current_office.replaceAll(quotation1, "''");
          }
          if (s.current_office.includes(quotation2)) {
            s.current_office = s.current_office.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_department_name != '' && s.current_department_name != null && s.current_department_name != undefined) {
        if (s.current_department_name.toString().length > 0) {
          if (s.current_department_name.includes(quotation1)) {
            s.current_department_name = s.current_department_name.replaceAll(quotation1, "''");
          }
          if (s.current_department_name.includes(quotation2)) {
            s.current_department_name = s.current_department_name.replaceAll(quotation2, "''");
          }
        }
      }


      return s;
    },
    getErrorTxt: function (student) {
      this.current_erorrtxt = "";
      var substring = "--";
      var zerochar = "00000";
      var substring00 = "00";
      var substring55 = "55";
      var substring55555 = "55555";
      var stringquestion = "??";
      var substring2="——";
      var substring3="__";
      var substring4="- -";
      var starstring="**";
      var pointstring='..';
      var nonestrint='None';
      this.numEror = 0;
      var s = this.checkQuotation(student);
      // else {
      if (s.selected_occup_type == "0") {
        // console.log("xxxxxxxxx")
        // if ((s.qn_occup_type_txt == "") || (s.qn_occup_type_txt == "None") || (s.qn_occup_type_txt == null) || (s.qn_occup_type_txt == "-") || (s.qn_occup_type_txt == "--")
        // ) {



        if ((s.qn_occup_type_txt == "") || (s.qn_occup_type_txt == "None") ||
          (s.qn_occup_type_txt == null) || (s.qn_occup_type_txt == "-") ||
          (s.qn_occup_type_txt == "--") || (s.qn_occup_type_txt == substring55555) ||
          (s.qn_occup_type_txt == zerochar) || (s.qn_occup_type_txt == substring00) ||
          (s.qn_occup_type_txt == stringquestion) || (s.qn_occup_type_txt == pointstring )
        )
        {
          this.numEror = this.numEror + 1;
          this.items2[0].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ประเภทงานที่ทำ" : this.current_erorrtxt + "/Other Occup type";
        } else {
          if (s.qn_occup_type_txt != "" && s.qn_occup_type_txt != null && s.qn_occup_type_txt != undefined) {
            if (s.qn_occup_type_txt.toString().length > 0) {

              if (s.qn_occup_type_txt.includes(substring) || s.qn_occup_type_txt.includes(substring2)
                || s.qn_occup_type_txt.includes(substring3) || s.qn_occup_type_txt.includes(substring4)
                || s.qn_occup_type_txt.includes(substring4)|| s.qn_occup_type_txt.includes(starstring)
                || s.qn_occup_type_txt.includes(pointstring)
              ) {
                this.numEror = this.numEror + 1;
                this.items2[0].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ประเภทงานที่ทำ --" : this.current_erorrtxt + "/Other Occup type --";
              }
              if (s.qn_occup_type_txt.includes(zerochar)) {
                this.numEror = this.numEror + 1;
                this.items2[0].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ประเภทงานที่ทำ 00000" : this.current_erorrtxt + "/Other Occup type 55";
              }
              if (s.qn_occup_type_txt.includes(substring55)) {
                this.numEror = this.numEror + 1;
                this.items2[0].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ประเภทงานที่ทำ 55" : this.current_erorrtxt + "/Other Occup type 55";
              }
              if (s.qn_occup_type_txt.includes(substring00)) {
                this.numEror = this.numEror + 1;
                this.items2[0].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ประเภทงานที่ทำ 00" : this.current_erorrtxt + "/Other Occup type 00";
              }
            }
          }
        }
      } else if (s.selected_occup_type == "4") {
        if ((s.qn_occup_type_txt4 == "") || (s.qn_occup_type_txt4 == "None") ||
          (s.qn_occup_type_txt4 == null) || (s.qn_occup_type_txt4 == "-") ||
          (s.qn_occup_type_txt4 == "--") || (s.qn_occup_type_txt4 == substring55555) ||
          (s.qn_occup_type_txt4 == zerochar) || (s.qn_occup_type_txt4 == substring00) ||
          (s.qn_occup_type_txt4 == stringquestion) || (s.qn_occup_type_txt4 == pointstring )
        ) {
          this.numEror = this.numEror + 1;
          this.items2[0].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โปรดระบุสินค้าหรือบริการ ดำเนินธุรกิจอิสระ/เจ้าของกิจการ (โปรดระบุสินค้า/บริการของท่าน)  " : this.current_erorrtxt + "/Please specify";
        } else {
          if (s.qn_occup_type_txt4 != "" && s.qn_occup_type_txt4 != null && s.qn_occup_type_txt4 != undefined) {
            if (s.qn_occup_type_txt4.toString().length > 0) {
              if (s.qn_occup_type_txt4.includes(substring) || s.qn_occup_type_txt4.includes(substring2)
                || s.qn_occup_type_txt4.includes(substring3) || s.qn_occup_type_txt4.includes(substring4)
                || s.qn_occup_type_txt4.includes(substring4)|| s.qn_occup_type_txt4.includes(starstring)
                || s.qn_occup_type_txt4.includes(pointstring)
              ) {
                this.numEror = this.numEror + 1;
                this.items2[0].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/โปรดระบุสินค้าหรือบริการ" : this.current_erorrtxt + "/Please specify";
              }
            }
          }
        }
      } else {
        if ((s.selected_occup_type == null) || (s.selected_occup_type == "")) {
          this.numEror = this.numEror + 1;
          this.items2[0].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ประเภทงานที่ทำ" : this.current_erorrtxt + "/Type of work 8888";
        }
      }
      if ((s.selected_talent == null) || (s.selected_talent == "")) {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ความสามารถพิเศษ" : this.current_erorrtxt + "/Talent";
      } else {
        if (s.selected_talent == "0") {
          if ((s.qn_talent_txt == "") || (s.qn_talent_txt == "None") || (s.qn_talent_txt == null) || (s.qn_talent_txt == "-") || (s.qn_talent_txt == "--")) {
            this.numEror = this.numEror + 1;
            this.items2[1].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ความสามารถพิเศษ" : this.current_erorrtxt + "/Other Talent";
          } else {
            if (s.qn_talent_txt != "" && s.qn_talent_txt != null && s.qn_talent_txt != undefined) {
              if (s.qn_talent_txt.toString().length > 0) {
                if (s.qn_talent_txt.includes(substring) || s.qn_talent_txt.includes(substring2)
                  || s.qn_talent_txt.includes(substring3) || s.qn_talent_txt.includes(substring4)
                  || s.qn_talent_txt.includes(substring4)|| s.qn_talent_txt.includes(starstring)
                  || s.qn_talent_txt.includes(pointstring)) {
                  this.numEror = this.numEror + 1;
                  this.items2[1].VALUES = 2;
                  this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ความสามารถพิเศษ --" : this.current_erorrtxt + "/Other Talent --";
                }
                if (s.qn_talent_txt.includes(substring55)) {
                  this.numEror = this.numEror + 1;
                  this.items2[1].VALUES = 2;
                  this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ความสามารถพิเศษ 55" : this.current_erorrtxt + "/Other Talent 55";
                }
                if (s.qn_talent_txt.includes(substring00)) {
                  this.numEror = this.numEror + 1;
                  this.items2[1].VALUES = 2;
                  this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ความสามารถพิเศษ 00" : this.current_erorrtxt + "/Other Talent 00";
                }
              }
            }
          }
        }
      }
      if (this.thai_student == "1") {
        if ((s.select_position == "") || (s.select_position == null) || (s.select_position == "None") || (s.select_position == 0)) {
          this.numEror = this.numEror + 1;
          this.items2[2].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตำแหน่ง" : this.current_erorrtxt + "";
        }
      } else {
        if ((s.thai_student == "0") && ((s.current_position == "") || (s.current_position == "-") || (s.current_position == "--") || (s.current_position == null) || (s.current_position == undefined))) {
          this.numEror = this.numEror + 1;
          this.items2[2].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/" : this.current_erorrtxt + "/Job position";
        } else {
          if (s.current_position != "" && s.current_position != null && s.current_position != undefined) {
            if (s.current_position.toString().length > 0) {
              if (s.current_position.includes(substring) || s.current_position.includes(substring2)
                || s.current_position.includes(substring3)|| s.current_position.includes(starstring)
                || s.current_position.includes(pointstring)  || s.current_position.includes(substring4) || s.current_position==nonestrint ) {
                this.numEror = this.numEror + 1;
                this.items2[2].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ --" : this.current_erorrtxt + "/Job position --";
              }
              if (s.current_position.includes(zerochar)) {
                this.numEror = this.numEror + 1;
                this.items2[2].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ 00000" : this.current_erorrtxt + "/Job position --";
              }
              if (s.current_position.includes(substring00)) {
                this.numEror = this.numEror + 1;
                this.items2[2].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ 00" : this.current_erorrtxt + "/Job position --";
              }
              if (s.current_position.includes(substring55)) {
                this.numEror = this.numEror + 1;
                this.items2[2].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ 55" : this.current_erorrtxt + "/Job position --";
              }
              if (s.current_position.includes(stringquestion)) {
                this.numEror = this.numEror + 1;
                this.items2[2].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ ?" : this.current_erorrtxt + "/Job position --";
              }
            }
          }
        }
      }
      if ((s.current_office == null) || (s.current_office == "") || (s.current_office == "-") || (s.current_office == "--") || (s.current_office == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[3].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/สถานที่ทำงาน" : this.current_erorrtxt + "/Company name";
      } else {

        if (s.current_office != null && s.current_office != "" && s.current_office != undefined) {
          // console.log("xx==",s.current_office)
          if (s.current_office.toString().length > 0) {
            if (s.current_office.includes(substring) || s.current_office.includes(substring2)
              || s.current_office.includes(substring3) || s.current_office.includes(starstring)
              || s.current_office.includes(pointstring) || s.current_office.includes(substring4)) {
              // console.log("xx")
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/สถานที่ทำงาน" : this.current_erorrtxt + "/Company name";
            }
            if (this.current_office.length < 3) {
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/สถานที่ทำงาน" : this.current_erorrtxt + "/Company name --";
            }
            if (s.current_office.includes(zerochar)) {
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/สถานที่ทำงาน" : this.current_erorrtxt + "/Company name";
            }
            if (s.current_office.includes(substring00)) {
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/สถานที่ทำงาน" : this.current_erorrtxt + "/Company name";
            }
            if (s.current_office.includes(substring55)) {
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/สถานที่ทำงาน" : this.current_erorrtxt + "/Company name";
            }
            if (s.current_office.includes(stringquestion)) {
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/สถานที่ทำงาน" : this.current_erorrtxt + "/Company name";
            }
          }
        }
      }
      if ((s.current_department_name == null) || (s.current_department_name == "") || (s.current_department_name == "-") || (s.current_department_name == "--") || (s.current_department_name == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[4].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ส่วนงาน/แผนก" : this.current_erorrtxt + "/Department name";
      } else {
        if (s.current_department_name != null && s.current_department_name != '' && s.current_department_name != undefined) {
          if (s.current_department_name.toString().length > 0) {
            if (s.current_department_name.includes(substring) || s.current_department_name.includes(substring2)
              || s.current_department_name.includes(substring3) || s.current_department_name.includes(starstring)
              || s.current_department_name.includes(pointstring) || s.current_department_name.includes(substring4)) {
              this.numEror = this.numEror + 1;
              this.items2[4].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ส่วนงาน หรือแผนก" : this.current_erorrtxt + "/Department name";
            }
            if (s.current_department_name.includes(zerochar)) {
              this.numEror = this.numEror + 1;
              this.items2[4].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ส่วนงาน หรือแผนก" : this.current_erorrtxt + "/Department name";
            }
            if (s.current_department_name.includes(substring00)) {
              this.numEror = this.numEror + 1;
              this.items2[4].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ส่วนงาน หรือแผนก" : this.current_erorrtxt + "/Department name";
            }
            if (s.current_department_name.includes(substring55)) {
              this.numEror = this.numEror + 1;
              this.items2[4].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ส่วนงาน หรือแผนก" : this.current_erorrtxt + "/Department name";
            }
            if (s.current_department_name.includes(stringquestion)) {
              this.numEror = this.numEror + 1;
              this.items2[4].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ส่วนงาน หรือแผนก" : this.current_erorrtxt + "/Department name";
            }
            if (s.current_department_name.length < 3) {
              this.numEror = this.numEror + 1;
              this.items2[4].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ส่วนงาน หรือแผนก" : this.current_erorrtxt + "/Department name";
            }
          }
        }
      }
      if ((s.selected_work_type == null) || (s.selected_work_type == 0) || (s.selected_work_type == "") || (s.selected_work_type == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[5].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ประเภทกิจการ" : this.current_erorrtxt + "/Career Fields";
      }
      /*  if ((this.select_country == null) || (this.select_country == 0) || (this.select_country == "None")) {
          this.numEror = this.numEror + 1;
          this.items2[6].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ประเทศ" : this.current_erorrtxt + "/Country";
        }*/
      // console.log("Before items2==", this.items2)
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      // return this.numEror;
      s.num_error = this.numEror;
      return s
    },
    nextPart() {
      if (this.selected_require_edu == 1) {
        this.$router.push("/part4?x=" + this.number);
      } else if (this.selected_require_edu == 2) {
        this.$router.push("/part5?x=" + this.number);
      }
    }
    ,
    updatePart2(student) {
      api
        .updateStudentPart2(student)
        .then(res => {
          // console.log(this.student);
          this.message = res.message;
          if (res.data.code == 200) {
            this.$router.push("part2_2?x=" + this.number);
          }
          // console.log("update ผ่าน", this.std_id);
          // this.nextPart();
        })
        .catch(err => {
          console.log("updatePart2 error", err.toString());
          // this.$router.push("Logout");
        });
    }
    ,
    onReset() {
      this.selected_occup_type = "";
      this.selected_talent = "";
      this.qn_occup_type_txt = "";
      this.qn_talent_txt = "";
      // this.QN_POS_ID="";
      this.select_position1 = "";
      this.current_office = "";
      this.selected_work_type = "";
      this.select_country1 = "";
      this.current_tel = "";
      this.current_fax = "";
      this.current_email = "";
      this.current_salary = "";
      this.selected_work_satisfy = "";
      this.qn_work_satisfy_txt = "";
      this.selected_time_findwork = "";
      this.selected_match_edu = "";
      this.selected_require_edu = "";
      this.selected_apply_edu = "";
      this.current_address = "";
    }
    ,
    onSubmit() {
      var student = {};
      student = this.setStudent();
      var s = this.getErrorTxt(student);
      // console.log("this.student", this.student);
      if (s.num_error == 0) {
        if (this.actionUpdate == 1) {
          this.updatePart2(s);
        } else {
          this.$router.push("/general");
        }
      }

      // console.log("ansChoose=", this.ansChoose);
    }
    ,
    getQuestion(section, sex, thaistudent, start) {

      api
        .getQuestionBySection(section, sex, thaistudent, start)
        .then(res => {
          var number, number2, number29;
          number = start;
          // console.log("คำถาม==",section,"==",res.data.data.length)
          if (section == 2) {
            var length = res.data.data.length;
            this.number = start + length;
            for (var i = 0; i < res.data.data.length; i++) {
              number = number + 1;
              res.data.data[i].NUMBER = number;
            }
            this.items = res.data.data;
            this.number = number;
            this.number20 = number;
          } else if (section == 21) {
            // console.log("1844select_country==",this.select_country)
            // console.log("1845.number==",this.number,this.number20)
            // if (this.select_country == 'TH') {
            //   var length21 = res.data.data.length;
            //   this.number21 = this.number20 + length21;
            //   for (var i = 0; i < length21; i++) {
            //     this.number20 = this.number20 + 1;
            //     // console.log("number20==",this.number20)
            //     res.data.data[i].NUMBER = this.number20;
            //   }
            //   this.item1s = res.data.data;
            //   this.number21 = this.number20;
            // } else {
            //   this.number21 = 12;
            // }
            // this.getQuestion(22, this.sex, this.thai_student, this.number21);
          } else if (section == 22) {//โทรสับ email fax
            // var length22 = res.data.data.length;
            // this.number22 = this.number21 + length22;
            // for (var i = 0; i < length22; i++) {
            //   this.number21 = this.number21 + 1;
            //   res.data.data[i].NUMBER = this.number21;
            // }
            // this.item2s = res.data.data;
            // this.number22 = this.number21;
            // this.getQuestion(23, this.sex, this.thai_student, this.number22);

          } else if (section == 23) { //24-33
            // for (var i = 0; i < res.data.data.length; i++) {
            // if (res.data.data[i].QUESTION_PK == 29) {
            //   number2 = number + 1;
            //   number29 = number + 1;
            //   res.data.data[i].NUMBER = number2;
            // } else if (res.data.data[i].QUESTION_PK == 30) {
            //   res.data.data[i].NUMBER = number29.toString() + ".1";
            //   // console.log(i, "==", res.data.data[i].QUESTION_PK, "==", res.data.data[i].NUMBER);
            // } else if (res.data.data[i].QUESTION_PK == 31) {
            //   res.data.data[i].NUMBER = number29.toString() + ".2";
            // } else if (res.data.data[i].QUESTION_PK == 32) {
            //   res.data.data[i].NUMBER = number29.toString() + ".3";
            // } else if (res.data.data[i].QUESTION_PK == 33) {
            //   number = number29 + 1;
            //   res.data.data[i].NUMBER = number;
            //   this.number = number;
            // } else {
            //   if (res.data.data[i].QUESTION_PK > 23) {
            //     number = number + 1;
            //     res.data.data[i].NUMBER = number;
            //   }
            // }
            // }
            this.item3s = res.data.data;
            // console.log("number==", this.number);
            // console.log("item3s==", res);

          }
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });

    }
    ,
    getPosition() {
      api
        .getPositionAll()
        .then(res => {
          this.positionItems = res.data.data;
          // console.log("positionItems==", res.data.data);
        })
        .catch(err => {
          console.log("getPosition", err.toString());
        });
    }
    ,
    getPostionById(id) {
      this.positionItems.value = id;
      // api
      //   .getPositionAll()
      //   .then(res => {
      //     this.positionItems = res.data.data;
      //     // console.log("positionItems==", res.data.data);
      //   })
      //   .catch(err => {
      //     console.log("getPosition", err.toString());
      //   });
    }
    ,
    getCountry(thaistudent) {
      api
        .getCountryAll(thaistudent)
        .then(res => {
          this.countryItems = res.data.data;
          // console.log("countryItems==", this.countryItems);
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    }
    ,
    getProvince(thaistudent) {
      api
        .getProvinceAll(thaistudent)
        .then(res => {
          this.provinceItems = res.data.data;
        })
        .catch(err => {
          console.log("getProvince", err.toString());
        });
    }
    ,
    selectProvinceOnchange: function () {
      this.onloadDistrictById(this.select_province);
      this.select_subdistrict = 0;
    }
    ,
    selectDistrictOnchange: function () {
      this.current_district = this.select_district;
      // console.log("this.select_district", this.select_district);
      this.onloadSubDistrictById(this.select_district);
    }
    ,
    selectSubDistrictOnchange: function () {
      this.onloadZipcodeById(this.select_subdistrict);
    }
    ,
    selectPositionOnchange: function () {
      this.current_position = this.select_position1.POS_NAME;
      this.select_position = this.select_position1.POS_ID;
      // console.log("select_position==", this.select_position);
      // console.log("select_position_name==", this.current_position);


    }
    ,
    selectCountryOnchange() {
      // console.log("--------selectCountryOnchange----------");
      this.select_country_name = this.select_country1.COUNTRYNAME;
      this.select_country = this.select_country1.COUNTRYID;
      // console.log("select_country_name", this.select_country1.COUNTRYNAME,this.select_country_name);
      // console.log("select_country", this.select_country1.COUNTRYID,this.select_country );
      // this.getQuestion(21, this.sex, this.thai_student, this.number20);
    }
    ,
    /*getCountryId: function(countryid) {
      api
        .getCountryById(countryid)
        .then(res => {
          this.select_country_name = res.data.data[0].COUNTRYNAME;

          return this.select_country_name;
        })
        .catch(err => {
          console.log("getCountryId", err.toString());
          return "";
        });
    }, */
    onloadDistrictById: async function () {
      api
        .getDistrictByid(this.select_province, this.thai_student)
        .then(res => {
          this.districtItems = res.data.data;
        })
        .catch(err => {
          console.log("onloadDistrictById", err.toString());
        });
    }
    ,
    onloadSubDistrictById: async function () {
      if (this.select_district != null) {
        api
          .getSubDistrictByid(this.select_district, this.thai_student)
          .then(res => {
            this.subdistrictItems = res.data.data;
            // this.select_subdistrict=select_sub;
            // console.log("res==",res);
            // console.log("xxxx",this.select_subdistrict);
          })
          .catch(err => {
            console.log("onloadSubDistrictById", err.toString());
          });
      }
    }
    ,
    onloadZipcodeById: async function () {
      api
        .getZipcode(this.select_subdistrict, this.thai_student)
        .then(res => {

          this.current_subdistrict = this.select_subdistrict;
          this.current_zipcode = res.data.data[0].ZIPCODE;
          this.select_subdistrict_name = res.data.data[0].SUB_DISTRICTNAME;
          // console.log("onloadZipcodeById", this.current_zipcode);
        })
        .catch(err => {
          console.log("onloadZipcodeById", err.toString());
        });
    }
  },
  mounted() {
  }
  ,
  created() {
    for (var j = 5; j <= 11; j++) { //ถามถึงประเทศ
      var b = {ID: j, UPDATEDATA: 0, VALUES: 0}
      this.items2.push(b);
    }
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    // console.log("$store==", this.$store.state.user.studentid);
    this.std_id = this.$store.state.user.studentid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    // this.select_country = 41;
    this.getStudentQuestion();

  }
}
;
</script>
<style>
</style>
